import { Component } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-utf-sync-info',
    templateUrl: './utf-sync-info.component.html',
    styleUrls: ['./utf-sync-info.component.scss'],
    standalone: false
})
export class UtfSyncInfoComponent extends CfetBaseComponent {
  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = true;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoInformationpage: boolean;
  stepTwoProfileDone: boolean;
  stepTwoDone = false;
  stepThreeIcon = false;
  openCancelModal = '';
  showCancelModal = false;
  progressTrackerStatus: any = 'registration';

  constructor() {
    super();
  }


  handleProgressTrackerEvent(event) {
    this.progressTrackerStatus = event;
  }

}
